import { MedicationModel } from "./Medication/MedicationModel";

export class PatientPrescriptionAdjustMedicationPopupModel {
    public baseMed: MedicationModel;
    public newMed: MedicationModel;
    public selectedCode: string;
    public ceaseDate: Date;
    public ceaseReason: string;
    public discontinueReasonLookupId: string | null;

    constructor(init: Partial<PatientPrescriptionAdjustMedicationPopupModel>) {
        Object.assign(this, init);
    }
}
